export default "__VITE_ASSET__Bf$1Vw92__"